import React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { startCase } from 'lodash';

import { HOSPITAL_NETWORK_PAGE_URL } from '@components/HospitalNetworkPage';
import { GARAGE_NETWORK_PAGE_URL } from '@components/GarageNetworkPage';

const ClaimNavDropdown = () => {
  const { t } = useTranslation();

  return (
    <NavDropdown title={startCase(t('common:claim'))} data-testid="claim-dropdown">
      <NavDropdown.Item as={Link} to="/user-dashboard/claim">
        {startCase(t('common:claims'))}
      </NavDropdown.Item>
      <NavDropdown.Item as={Link} to={HOSPITAL_NETWORK_PAGE_URL}>
        {startCase(t('common:hospitalNetwork'))}
      </NavDropdown.Item>
      <NavDropdown.Item as={Link} to={GARAGE_NETWORK_PAGE_URL}>
        {startCase(t('common:garageNetwork'))}
      </NavDropdown.Item>
    </NavDropdown>
  );
};

export { ClaimNavDropdown };
